import { render } from "./index.vue?vue&type=template&id=2930e562&scoped=true&ts=true"
import script from "./component.ts?vue&type=script&lang=ts"
export * from "./component.ts?vue&type=script&lang=ts"

import "./style.sass?vue&type=style&index=0&id=2930e562&lang=sass&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2930e562"]])

export default __exports__